import { blipWebsocketHostName, blipDomainUrl, blipWebsocketHostNameTenant, builderObservabilitySettingsSource, } from 'app.constants';
export class BuilderObservabilityController {
    static $inject = ['LoadingService', 'TranslateService', 'application', 'AccountService2'];
    constructor(LoadingService, TranslateService, application, AccountService2) {
        this.LoadingService = LoadingService;
        this.TranslateService = TranslateService;
        this.application = application;
        this.AccountService2 = AccountService2;
        this.LoadingService.startLoading();
        const setProps = async () => {
            const account = await this.AccountService2.me();
            this.language = this.TranslateService.getCurrentLanguage();
            this.ownerIdentity = this.application.shortName;
            this.webSocketParams = {
                blipDomainUrl,
                blipWebsocketHostName,
                blipWebsocketHostNameTenant,
            };
            this.LoadingService.stopLoading();
            this.settingsSource = builderObservabilitySettingsSource;
            this.user = account;
            this.tenantId = this.application.tenantId;
            this.isRouter = this.application.template === 'master';
        };
        setProps();
    }
}
BuilderObservabilityController.$inject = ['LoadingService', 'TranslateService', 'application', 'AccountService2'];
